module.exports = __webpack_public_path__ + "static/media/photo-2.86d4751a.webp";